var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    metricsPadding: spacing.medium,
    cardHeight: '6rem',
    cardWidth: '19.5rem',
    cardPadding: spacing.medium,
    cardMargin: spacing.xSmall,
    quizSummaryBorderBottomColor: colors.tiara
  };
};
export default generateComponentTheme;